import { Button, Stack } from '@mui/material';
import { useParams } from 'react-router';

import { FCWithChildren } from '/common/models';
import { EvnToggler } from '/component/Support/shared';

import { handleClick } from '../../helpers';
import { IBeetleParams, SupportContentType } from '../../types';

export const HeaderContainer: FCWithChildren<{ beetleType?: SupportContentType; showEnv?: boolean }> = ({
  children,
  beetleType = SupportContentType.EMPTY,
  showEnv = true,
}) => {
  const modifiedText = beetleType?.replace(/.*(?=attachments)|_/g, ' ');
  const { appName, env } = useParams<IBeetleParams>();

  return (
    <Stack spacing={4} direction='row' alignItems='center'>
      {children !== undefined ? (
        children
      ) : (
        <Button variant='text' onClick={handleClick({ type: beetleType, appName, env })}>
          {modifiedText}
        </Button>
      )}

      {showEnv ? <EvnToggler /> : null}
    </Stack>
  );
};
